import template from './transfer.component.html';
import * as TransferActions from '../../state/transfer/transfer.actions';
import * as TableColumnsActions from '../../state/table-columns/table-columns.action';

class TransferController {
  constructor($ngRedux, $timeout) {
    'ngInject';
    this.showFlyout = false;
    this.transferInitiated = this.verifyTransfer = false;
    this.targetAccountKey = null;
    this.errorMessage = null;
    this.showTransferDetails = false;
    this.timeout = $timeout;

    this.store = $ngRedux;
    this.unsubscribe = this.store.connect(this.mapStateToThis, { ...TransferActions, ...TableColumnsActions })(this);
  }

  mapStateToThis(state) {
    const { transfer, tableColumns } = state;
    const { transferkeys, transferAssets = [], transferStatus } = transfer;
    const { columns, selected = [] } = tableColumns;

    return {
      transferAssetsList: transferAssets,
      accountsTransferkeys: transferkeys,
      columns,
      selected,
      transferStatus
    };
  }

  $onDestroy() {
    this.resetTransfers();
    this.unsubscribe();
  }

  toggleFlyout() {
    this.showFlyout = !this.showFlyout;
    if (this.showFlyout) {
      const transferableCol = this.columns.transferrable;
      if (!this.selected.find(selectedCol => selectedCol.key === transferableCol.key)) {
        this.toggleColumn(transferableCol);
      }
    } else {
      this.resetPrevious();
    }
  }

  initiateTransfer() {
    this.resetPrevious();
    this.transferInitiated = true;
    this.timeout(() => {
      this.verifyTransfer = true;
    }, 200);
  }

  resetPrevious() {
    this.resetTransfers();
  }

  cancelTransfer() {
    this.transferInitiated = this.verifyTransfer = false;
  }

  confirmTransfer() {
    if (this.getNumberOfSelectedAssets() > 0 && this.targetAccountKey) {
      this.transferInitiated = this.verifyTransfer = false;
      this.initiateAssetTransfer(this.getSelectedAsset(), this.targetAccountKey);
    }
  }

  getSelectedAsset() {
    return this.assets.filter(asset => asset.selected && asset.selected === true);
  }

  getNumberOfSelectedAssets() {
    return this.assets.filter(asset => asset.selected && asset.selected === true).length;
  }

  showErrorMessage(id) {
    if (this.errorMessageId === id) {
      this.errorMessageId = null;
    } else {
      this.errorMessageId = id;
    }
  }
}

export default {
  template,
  restrict: 'E',
  bindings: {
    assets: '<'
  },
  controller: TransferController,
  controllerAs: 'vm'
};
